import { render, staticRenderFns } from "./LiveChat.vue?vue&type=template&id=846b7348&scoped=true&"
import script from "./LiveChat.vue?vue&type=script&lang=js&"
export * from "./LiveChat.vue?vue&type=script&lang=js&"
import style0 from "./LiveChat.vue?vue&type=style&index=0&id=846b7348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846b7348",
  null
  
)

export default component.exports